<template>
  <div>
    <v-text-field
      :label="label"
      :required="required"
      :value="displayValue"
      @focus="openPicker"
      hide-details
    />
    <div class="data-range-picker elevation-1" v-show="picker" @click.prevent="closePicker">
      <div class="inner" @click.stop>
        <form @submit.prevent="closePicker">
          <date-time v-model="from" :label="$t('time.from')" />
          <date-time v-model="to" :label="$t('time.to')" />

          <div class="text-xs-right"><v-btn type="submit" flat success>OK</v-btn></div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import DateTime from './DateTime'
// import moment from 'moment'

export default {
  props: {
    value: String,
    label: String,
    required: Boolean
  },
  data () {
    let from = null
    let to = null

    if (this.value) {
      if (this.value.indexOf('|') >= 0) {
        let values = this.value.split('|')
        from = values[0]
        to = values[1]
      }
    }

    return {
      picker: false,
      from,
      to
    }
  },
  watch: {
    from () {
      this.updateValue()
    },
    to () {
      this.updateValue()
    },
    value () {
      if (!this.value || this.value.indexOf('|') < 0) {
        this.from = null
        this.to = null
      }

      let values = this.value.split('|')
      this.from = values[0]
      this.to = values[1]
    }
  },
  computed: {
    displayValue () {
      if (this.from || this.to) {
        return (this.from ? this.$format.date(this.from) : '*') + ' - ' + (this.to ? this.$format.date(this.to) : '*')
      }
    }
  },
  methods: {
    updateValue () {
      let value = (this.from || '') + '|' + (this.to || '')
      this.$emit('input', value)
    },
    closePicker () {
      this.picker = false
    },
    openPicker () {
      this.picker = true
    }
  },
  components: {
    DateTime
  }
}
</script>

<style>
.data-range-picker {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
}

.data-range-picker .inner {
  background: #fff;
  padding: 1em;
  margin-top: 10%;
}
</style>



// WEBPACK FOOTER //
// DateRange.vue?51d10cea